import { MdAnalytics } from "react-icons/md";

import { Button } from "./Button";

const posthogActivityExploreBase = "https://eu.posthog.com/project/62408/activity/explore";

const getPostHogActivityExploreUrl = (userId: string): string => {
  const q = {
    kind: "DataTableNode",
    full: true,
    source: {
      kind: "EventsQuery",
      select: [
        "*",
        "event",
        "person_display_name -- Person",
        "coalesce(properties.$current_url, properties.$screen_name) -- Url / Screen",
        "properties.$lib",
        "timestamp",
      ],
      orderBy: ["timestamp DESC"],
      after: "-30d",
      properties: [
        { key: "$user_id", value: [userId], operator: "exact", type: "event" },
      ],
      filterTestAccounts: false,
    },
    propertiesViaUrl: true,
    showSavedQueries: true,
    showPersistentColumnConfigurator: true,
  };
  return `${posthogActivityExploreBase}#q=${encodeURIComponent(JSON.stringify(q))}`;
};

type Props = {
  userId: string;
};

export const PostHogUserButton: React.FC<Props> = ({ userId }) => (
  <Button
    variant="outline"
    icon={<MdAnalytics />}
    onClick={() => window.open(getPostHogActivityExploreUrl(userId), "_blank", "noopener,noreferrer")}
  >
    PostHog – użytkownik
  </Button>
);
